import React from "react";
import { ReportMetaField } from "./ReportMetaField";

export function ReportHeaderFields({ fields, variant = "print", className = "" }) {
  if (!fields?.length) return null;

  return (
    <div
      className={["report-header-fields", "erp-panel-body", className]
        .filter(Boolean)
        .join(" ")}
    >
      {fields.map((field) => (
        <ReportMetaField
          key={field.key}
          label={field.label}
          value={field.value}
          variant={variant}
        />
      ))}
    </div>
  );
}
